var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#00AB58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5817 27V25.0966L20.6314 20.1463C21.1143 19.6586 21.5168 19.2254 21.8388 18.8466C22.1607 18.4678 22.4022 18.1009 22.5632 17.7457C22.7242 17.3906 22.8047 17.0118 22.8047 16.6094C22.8047 16.1501 22.7005 15.7571 22.4922 15.4304C22.2839 15.099 21.9974 14.8433 21.6328 14.6634C21.2682 14.4834 20.8539 14.3935 20.3899 14.3935C19.9117 14.3935 19.4927 14.4929 19.1328 14.6918C18.773 14.8859 18.4936 15.1629 18.2947 15.5227C18.1006 15.8826 18.0036 16.3111 18.0036 16.8082H15.4964C15.4964 15.8849 15.7071 15.0824 16.1286 14.4006C16.55 13.7187 17.13 13.1908 17.8686 12.8168C18.612 12.4427 19.4643 12.2557 20.4254 12.2557C21.4008 12.2557 22.2578 12.438 22.9964 12.8026C23.7351 13.1671 24.308 13.6667 24.7152 14.3011C25.1271 14.9356 25.3331 15.66 25.3331 16.4744C25.3331 17.0189 25.2289 17.554 25.0206 18.0795C24.8123 18.6051 24.4453 19.1875 23.9197 19.8267C23.3989 20.4659 22.6674 21.2401 21.7251 22.1491L19.218 24.6989V24.7983H25.5533V27H15.5817Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2);
export default __webpack_public_path__ + "static/media/Circle-2.e0c07475398d6087a69fead53d099999.svg";
export { ForwardRef as ReactComponent };